import React from 'react'
import styled from 'styled-components'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'
import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'

const resource = createResource({
  en: {
    title: `Our Pillars`,
    visionTitle: 'Vision: ',
    visionContent: 'Advance with intelligence for a better life',
    missionTitle: 'Mission: ',
    missionContent:
      'Make products, services and opportunities accessible and affordable to everyone and every business',
    valueTitle: 'Value: ',
    valueContent: 'Customers Centric, Data Centric and People Centric',
    coreTitle: 'Core Culture: ',
    coreContent: 'Innovation, Collaboration, Integrity, Efficiency, Quality',
  },
  id: {
    title: 'Pilar Kami',
    visionTitle: 'Vision: ',
    visionContent: 'Advance with intelligence for a better life',
    missionTitle: 'Mission: ',
    missionContent:
      'Make products, services and opportunities accessible and affordable to everyone and every business',
    valueTitle: 'Value: ',
    valueContent: 'Customers Centric, Data Centric and People Centric',
    coreTitle: 'Core Culture: ',
    coreContent: 'Innovation, Collaboration, Integrity, Efficiency, Quality',
  },
})

const Pillars = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  return (
    <BannerBox>
      {width >= 1000 ? (
        <div className="container">
          <div className="right-content">
            <div className="title">{t('title')}</div>
            <div className="content">
              <div className="pillar-item">
                <span className="item-title">{t('visionTitle')}</span>
                <span className="item-content">{t('visionContent')}</span>
              </div>
              <div className="pillar-item">
                <span className="item-title">{t('missionTitle')}</span>
                <span className="item-content">{t('missionContent')}</span>
              </div>
              <div className="pillar-item">
                <span className="item-title">{t('valueTitle')}</span>
                <span className="item-content">{t('valueContent')}</span>
              </div>
              <div className="pillar-item">
                <span className="item-title">{t('coreTitle')}</span>
                <span className="item-content">{t('coreContent')}</span>
              </div>
            </div>
          </div>
          <div className="left-image">
            <LazyLoad>
              <Image src="/images/career/pillars.png" alt="Pilar Kami" width={440} height={396} quality={85} />
            </LazyLoad>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="title">{t('title')}</div>
          <div className="left-image">
            <LazyLoad>
              <Image src="/images/career/pillars.png" alt="Pilar Kami" width={288} height={259} quality={85} />
            </LazyLoad>
          </div>
          <div className="right-content">
            <div className="content">
              <div className="pillar-item">
                <span className="item-title">{t('visionTitle')}</span>
                <span className="item-content">{t('visionContent')}</span>
              </div>
              <div className="pillar-item">
                <span className="item-title">{t('missionTitle')}</span>
                <span className="item-content">{t('missionContent')}</span>
              </div>
              <div className="pillar-item">
                <span className="item-title">{t('valueTitle')}</span>
                <span className="item-content">{t('valueContent')}</span>
              </div>
              <div className="pillar-item">
                <span className="item-title">{t('coreTitle')}</span>
                <span className="item-content">{t('coreContent')}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </BannerBox>
  )
}

export default Pillars

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 48px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      position: relative;
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      .title {
        font-size: 32px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 36px;
        text-align: center;
        padding-bottom: 16px;
      }
      .right-content {
        .content {
          padding-top: 20px;
          .pillar-item {
            padding-top: 18px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 400;
            font-size: 16px;
            line-height: 32px;
            .item-title {
              color: #1cc812;
            }
            .item-content {
              font-family: Roboto-Regular, Roboto;
              color: #757575;
            }
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    background-repeat: no-repeat;
    .container {
      height: 410px;
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 150px;
      .left-image {
        width: 440px;
        height: 396px;
      }
      .right-content {
        width: 576px;
        .title::before {
          content: '-';
          background: #1cc812;
          color: transparent;
          margin-right: 16px;
        }
        .title {
          font-size: 32px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 36px;
          padding-top: 40px;
        }
        .content {
          padding-top: 20px;
          .pillar-item {
            padding-top: 24px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            font-size: 16px;
            line-height: 32px;
            .item-title {
              color: #1cc812;
            }
            .item-content {
              color: #212121;
            }
          }
        }
      }
    }
  }
`
